
import { SearchRequestDto } from 'src/app/shared/search-request-dto';
import { RangeStep } from './aggregation-serie';

export class AggregationRequestDto extends SearchRequestDto {
    aggregationKeys: { [index: number]: string } = {};
    type: string;
    types: string[];
    metricField: string;
    timestampField: string;
    aggregationInterval: number;
    isTimeserie: boolean = true;
    weighted: boolean = false;
    weightField: string = null;
    size: number = 10;
    topValues: boolean = true;
    weightSumField:string = null;
    numericRangeField: string = null;
    range: Record<string, RangeStep[]> = {"steps": []};
}
